export default __webpack_public_path__ + "static/media/blgn_spght.ab71d5b6.jpg";